import {
  Component,
  OnInit,
  ChangeDetectionStrategy,
  Input,
  Output,
  EventEmitter,
  ChangeDetectorRef,
} from '@angular/core';
import { merge, Observable } from 'rxjs';
import { InlineToastMessage, InlineToastType } from '../inline-toast/inline-toast.component';
import { CollectionManageAccessFacade } from '@mode/collections/domain';
import { map, tap } from 'rxjs/operators';

const DefaultAccessUpdateSuccessMessage: InlineToastMessage = {
  message: 'Updated',
  type: InlineToastType.Success,
};

const DefaultAccessUpdateErrorMessage: InlineToastMessage = {
  message: 'Error',
  type: InlineToastType.Error,
};

@Component({
  selector: 'mode-default-access-inline-toast',
  templateUrl: './default-access-inline-toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultAccessInlineToastComponent implements OnInit {
  @Input()
  placement!: string;

  @Output()
  done = new EventEmitter<void>();

  toast$!: Observable<InlineToastMessage>;

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private collectionManageAccessFacade: CollectionManageAccessFacade
  ) {}

  ngOnInit(): void {
    this.toast$ = merge(
      this.collectionManageAccessFacade.defaultAccessUpdateSuccess$.pipe(
        map(() => ({ ...DefaultAccessUpdateSuccessMessage }))
      ),
      this.collectionManageAccessFacade.defaultAccessUpdateError$.pipe(
        map(() => ({ ...DefaultAccessUpdateErrorMessage }))
      )
    ).pipe(tap(() => this.changeDetectorRef.markForCheck()));
  }

  toastComplete() {
    this.done.emit();
  }
}
